import React, { useState, useRef, useEffect } from "react";
import "./pageSix.css";
import useBlockHorizontalScroll from "../../hooks/useBlockHorizontalScroll"; // import the hook above

import res_1 from "../../img/resource1_page_6.gif";
import res_2 from "../../img/finalBGVideoCutted.mp4";
import Core from "../core";
import arrowImage from "../../img/formArrow.svg";
import arrowBackImage from "../../img/arrowBack.svg";
import formWhiteCross from "../../img/formWhiteCross.svg";

function PageSix() {
  const [showVideo, setShowVideo] = useState(false);
  const [showText, setShowText] = useState(false);
  const [showEmailBox, setShowEmailBox] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [formStage, setFormStage] = useState("email");
  const [thankYouVisible, setThankYouVisible] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formClosing, setFormClosing] = useState(false);
  const [fadeOutInitialElements, setFadeOutInitialElements] = useState(false);

  const emailInputRef = useRef(null);
  const messageInputRef = useRef(null);
  const videoRef = useRef(null);

  // **1)** Use the custom hook to block horizontal swipes
  // when showVideo === true
  useBlockHorizontalScroll(showVideo);

  // **2)** Toggle 'no-scroll-x' on body for extra measure
  useEffect(() => {
    console.log("[useEffect showVideo]: showVideo changed =>", showVideo);
    if (showVideo) {
      console.log("[useEffect showVideo]: Adding .no-scroll-x to body");
      document.body.classList.add("no-scroll-x");
    } else {
      console.log("[useEffect showVideo]: Removing .no-scroll-x from body");
      document.body.classList.remove("no-scroll-x");
    }

    return () => {
      document.body.classList.remove("no-scroll-x");
    };
  }, [showVideo]);

  // **(Optional)** If you want to also block horizontal mouse wheel:
  useEffect(() => {
    function handleWheel(e) {
      if (showVideo && e.deltaX !== 0) {
        console.log(
          "[handleWheel]: Blocking horizontal scroll => deltaX =",
          e.deltaX
        );
        e.preventDefault();
      }
    }

    window.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      window.removeEventListener("wheel", handleWheel, { passive: false });
    };
  }, [showVideo]);

  const handleVideoPlay = () => {
    console.log(
      "[handleVideoPlay]: Starting timers to show text + email prompt"
    );
    setTimeout(() => {
      console.log("[handleVideoPlay]: setShowText(true)");
      setShowText(true);
    }, 3000);
    setTimeout(() => {
      console.log("[handleVideoPlay]: setShowEmailBox(true)");
      setShowEmailBox(true);
    }, 4000);
  };

  const handleButtonClick = () => {
    console.log("[PageSix] Dispatch event: disable Splide drag");
    window.dispatchEvent(
      new CustomEvent("toggleSplideDrag", {
        detail: { disabled: true },
      })
    );

    console.log(
      "[handleButtonClick]: Fading out initial elements. Then showVideo in 1s."
    );
    setFadeOutInitialElements(true);

    // Hide Splide arrows
    const splideArrows = document.querySelectorAll(".splide__arrows");
    splideArrows.forEach((arrow) => {
      arrow.style.display = "none";
      console.log("[handleButtonClick]: Hiding Splide arrow =>", arrow);
    });

    // Also disable pointer events on .splide
    const splideContainer = document.querySelector(".splide");
    if (splideContainer) {
      console.log(
        "[handleButtonClick]: Disabling pointer events on .splide => .splide-disabled"
      );
      splideContainer.classList.add("splide-disabled");
    }

    setTimeout(() => {
      handleVideoPlay();
      console.log("[handleButtonClick]: Setting showVideo = true");
      setShowVideo(true);
    }, 1000);
  };

  const handleCloseVideo = () => {
    console.log("[handleCloseVideo]: Fade out, then reset state in 1.5s");
    setFormClosing(true);

    console.log("[PageSix] Dispatch event: enable Splide drag");
    window.dispatchEvent(
      new CustomEvent("toggleSplideDrag", {
        detail: { disabled: false },
      })
    );

    // Restore Splide arrows
    const splideArrows = document.querySelectorAll(".splide__arrows");
    splideArrows.forEach((arrow) => {
      console.log("[handleCloseVideo]: Restoring Splide arrow =>", arrow);
      arrow.style.display = "block";
    });

    // Re-enable pointer events on .splide
    const splideContainer = document.querySelector(".splide");
    if (splideContainer) {
      console.log(
        "[handleCloseVideo]: Re-enabling pointer events on .splide => .splide-disabled removed"
      );
      splideContainer.classList.remove("splide-disabled");
    }

    setTimeout(() => {
      console.log("[handleCloseVideo]: Resetting state now");
      setShowVideo(false);
      setShowEmailBox(false);
      setShowText(false);
      setEmail("");
      setMessage("");
      setFormStage("email");
      setThankYouVisible(false);
      setFormSubmitted(false);
      setFormClosing(false);
      setFadeOutInitialElements(false);
    }, 1500);
  };

  const handleArrowClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (formStage === "email") {
      console.log("[handleArrowClick]: email => message stage");
      setFormStage("message");
      setShowText(false);
    }
  };

  const handleBackArrowClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (formStage === "message") {
      console.log("[handleBackArrowClick]: message => email stage");
      setFormStage("email");
      setShowText(true);
    }
  };

  const handleInputChange = (e) => {
    console.log("[handleInputChange]: email =>", e.target.value);
    setEmail(e.target.value);
  };

  const handleMessageChange = (e) => {
    console.log("[handleMessageChange]: message =>", e.target.value);
    setMessage(e.target.value);
  };

  const handleSubmission = async () => {
    console.log("[handleSubmission]: Submitting =>", email, message);
    setFormSubmitted(true);

    let country = "Unknown";
    try {
      const ipResponse = await fetch("https://ipapi.co/json/");
      const ipData = await ipResponse.json();
      country = ipData.country_name || "Unknown";
      console.log("[handleSubmission]: Detected country =>", country);
    } catch (err) {
      console.error("[handleSubmission]: Error detecting country =>", err);
    }

    try {
      const response = await fetch("/api/sendEmail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          businessMessage: message,
          country,
        }),
      });
      if (!response.ok) {
        console.error(
          "[handleSubmission]: Error sending email => status:",
          response.status
        );
      } else {
        console.log("[handleSubmission]: Email sent successfully!");
      }
    } catch (err) {
      console.error("[handleSubmission]: Error sending email =>", err);
    }

    setTimeout(() => {
      console.log("[handleSubmission]: Hide form, show 'thank you'");
      setShowEmailBox(false);
      setMessage("");
      setEmail("");
      setFormStage("email");
      setFormSubmitted(false);
      setThankYouVisible(true);

      // Optionally restart the video
      const videoElement = videoRef.current;
      if (videoElement) {
        console.log("[handleSubmission]: Re-playing video");
        videoElement.play();
      }
    }, 1500);
  };

  const handleVideoTimeUpdate = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      const current = videoElement.currentTime;
      // console.log("[handleVideoTimeUpdate] => time:", current);
      if (!thankYouVisible && current >= 5.5) {
        console.log(
          "[handleVideoTimeUpdate]: Pausing at 5.5s. Wait for 'thank you'..."
        );
        videoElement.pause();
      } else if (thankYouVisible && videoElement.ended) {
        console.log(
          "[handleVideoTimeUpdate]: ended after 'thank you', closing overlay."
        );
        handleCloseVideo();
      }
    }
  };

  const isEmailValid = (str) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const valid = emailRegex.test(str);
    console.log("[isEmailValid]: checking =>", str, " =>", valid);
    return valid;
  };

  // Focus logic
  useEffect(() => {
    if (showEmailBox && formStage === "email" && emailInputRef.current) {
      console.log("[focusEffect]: focusing email input");
      emailInputRef.current.focus();
    } else if (formStage === "message" && messageInputRef.current) {
      console.log("[focusEffect]: focusing message textarea");
      messageInputRef.current.focus();
    }
  }, [showEmailBox, formStage]);

  return (
    <div
      className={`page_container ${showVideo ? "dim-background" : ""} ${
        formClosing ? "fade-out" : ""
      }`}
    >
      <p className={`tittle-page ${fadeOutInitialElements ? "fade-out" : ""}`}>
        Begin
      </p>
      <p
        className={`paragraph-page-bold ${
          fadeOutInitialElements ? "fade-out" : ""
        }`}
      >
        Ready to move beyond the confines of conventional wisdom? Let’s define
        new standards in strategy—together.
      </p>

      <button
        className={`open-video-button ${
          fadeOutInitialElements ? "fade-out" : ""
        }`}
        onClick={handleButtonClick}
      >
        <Core image={res_1} tittle="" description="" extraStyle="-dif5" />
      </button>

      {showVideo && (
        <div className="video-overlay fade-in-smooth">
          <video
            ref={videoRef}
            src={res_2}
            autoPlay
            muted
            playsInline
            webkit-playsinline
            className="fullscreen-video"
            onTimeUpdate={handleVideoTimeUpdate}
          />
          <img
            src={formWhiteCross}
            className="close-video-button"
            onClick={handleCloseVideo}
            alt="Close"
          />
        </div>
      )}

      {showText && formStage === "email" && !thankYouVisible && (
        <div className={`form-initial-text ${showEmailBox ? "pushed-up" : ""}`}>
          <p className="hello-text">Hello,</p>
        </div>
      )}

      {showEmailBox && formStage === "email" && (
        <div className="form-email-container">
          <p className="email-prompt-text">What's your email?</p>
          <input
            type="text"
            className="email-input"
            value={email}
            onChange={handleInputChange}
            ref={emailInputRef}
          />
          <img
            src={arrowImage}
            alt="Arrow"
            className={`arrow-image ${
              email && isEmailValid(email) ? "clickable" : ""
            }`}
            onClick={(e) => {
              if (email && isEmailValid(email)) {
                handleArrowClick(e);
              }
            }}
          />
        </div>
      )}

      {showEmailBox && formStage === "message" && (
        <div
          className={`form-message-container ${
            formSubmitted ? "fade-out" : ""
          }`}
        >
          <p className="email-prompt-text2">Let us know how we can help</p>
          <textarea
            className="message-input"
            value={message}
            onChange={handleMessageChange}
            ref={messageInputRef}
          />
          <button
            className={`submit-button ${message ? "clickable" : ""}`}
            onClick={message ? handleSubmission : undefined}
            disabled={!message}
          >
            Submit
          </button>
          <img
            src={arrowBackImage}
            alt="Back Arrow"
            className="arrow-back-image"
            onClick={handleBackArrowClick}
          />
        </div>
      )}

      {thankYouVisible && (
        <div className="thank-you-text fade-in">
          <p className="thank-you-message">Thank you!</p>
          <p className="thank-you-submessage">We'll contact you shortly.</p>
        </div>
      )}
    </div>
  );
}

export default PageSix;
